import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowLeft } from "lucide-react";

export default function GameReport() {
  const { gameId } = useParams();
  const [r, setR] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.get(`/reports/${gameId}`).then((x) => setR(x.data)).catch((e) => setErr(e?.response?.data?.detail || "Rapor yok"));
  }, [gameId]);

  if (err) return <div className="min-h-screen dark bg-[#070B14] text-white p-8">{err}</div>;
  if (!r) return <div className="min-h-screen dark bg-[#070B14] text-white p-8">Yükleniyor…</div>;

  const per = [...(r.per_idiom || [])].sort((a, b) => a.overall - b.overall);
  const hardest = per.slice(0, 3);
  const best = per.slice(-3).reverse();

  return (
    <div className="min-h-screen dark bg-[#070B14] text-white">
      <div className="max-w-5xl mx-auto px-6 py-10">
        <Link to="/teacher" className="text-zinc-400 text-sm inline-flex items-center gap-1"><ArrowLeft className="h-4 w-4"/> Panel</Link>
        <h1 className="mt-6 font-heading text-4xl font-bold">Bugünün Öğrenme Raporu</h1>
        <p className="text-zinc-400">Kod: {r.code} • Paket: {r.pack_key}</p>

        <div className="mt-8 grid sm:grid-cols-3 gap-4">
          <KPI label="Katılımcı" value={r.participant_count}/>
          <KPI label="Deyim" value={r.idiom_count}/>
          <KPI label="Ort. Yanıt" value={`${r.avg_response_seconds} sn`}/>
          <KPI label="Deyimi Yakalama" value={`${r.idiom_rate}%`}/>
          <KPI label="Anlamını Yakalama" value={`${r.meaning_rate}%`}/>
          <KPI label="Bağlamı Yakalama" value={`${r.context_rate}%`}/>
        </div>

        <section className="mt-12 grid md:grid-cols-2 gap-6">
          <IdiomList title="En Çok Zorlanılan Deyimler" items={hardest} tone="red"/>
          <IdiomList title="En Başarılı Olunan Deyimler" items={best} tone="emerald"/>
        </section>

        <section className="mt-12">
          <h2 className="font-heading text-xl font-bold">Podyum</h2>
          <div className="mt-4 rounded-2xl border border-white/10 overflow-hidden">
            {r.podium.slice(0, 10).map((p, i) => (
              <div key={i} className="grid grid-cols-6 items-center px-5 py-3 border-b border-white/5 last:border-0">
                <div className="col-span-1 text-cyan-300 font-heading">{i+1}</div>
                <div className="col-span-4 truncate">{p.name}</div>
                <div className="col-span-1 text-right font-heading tabular-nums">{p.score}</div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

const KPI = ({ label, value }) => (
  <div className="rounded-2xl border border-white/10 bg-zinc-950/70 p-5">
    <div className="text-xs font-heading text-zinc-500 tracking-widest">{label.toUpperCase()}</div>
    <div className="mt-2 font-heading text-3xl font-bold">{value}</div>
  </div>
);

const IdiomList = ({ title, items, tone }) => (
  <div>
    <h3 className="font-heading text-lg font-bold">{title}</h3>
    <div className="mt-3 space-y-2">
      {items.map((it, i) => (
        <div key={i} className="rounded-xl border border-white/10 bg-zinc-950/70 p-4">
          <div className="font-literary italic">"{it.idiom}"</div>
          <div className="text-zinc-500 text-xs mt-1">{it.artist} — {it.song}</div>
          <div className="mt-2 flex gap-3 text-xs text-zinc-400">
            <span>D: <span className="text-white">{it.idiom_rate}%</span></span>
            <span>A: <span className="text-white">{it.meaning_rate}%</span></span>
            <span>B: <span className="text-white">{it.context_rate}%</span></span>
            <span className={`ml-auto font-heading ${tone === "red" ? "text-red-300" : "text-emerald-300"}`}>{it.overall}%</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);
